import { createReducer, on } from '@ngrx/store';
import * as PaymentTermsActions from './payment-terms.actions';

export interface PaymentTermsState {
  response: any[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: any[] };
}

export const initialState: PaymentTermsState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const paymentTermsReducer = createReducer(
  initialState,
  on(PaymentTermsActions.loadPaymentTerms, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PaymentTermsActions.loadPaymentTermsSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(PaymentTermsActions.loadPaymentTermsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(PaymentTermsActions.loadPaymentTermsSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
